var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ticket-package'),_c('el-row',{staticClass:"margintop20",attrs:{"type":"flex","justify":"center"}},[_c('el-button',{on:{"click":_vm.handleClick}},[_vm._v(_vm._s(_vm.$t('button.cancel')))]),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.handleClick}},[_vm._v(_vm._s(_vm.$t('button.confirm')))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }